import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { gameService } from '../../../../services/gameService';

import { winBarStore } from '../../../../store/winBarStore';
import { freeBetStore } from '../../../../store/freeBetStore';
import { bettingPartStore } from '../../../../store/bettingPartStore';
import { applicationStore } from '../../../../store/applicationStore';

import { getGameImages } from '../../../../core/helpers/getGameImages';
import { amountContainerInfo } from '../../../../core/constants/amountContainerInfo';

import Button from '../../button';

const FreeBetFooter = observer(() => {
  const { isFreeBetEnd, freeBetList, updateFreeBetInfo, showFreeBetInfo, setIsShowFreeBetPopup } =
    freeBetStore;

  const {
    canvasTranslationKeys: { OK, PLAY },
  } = applicationStore;

  const { playButtonBgHovered, playButtonBgDefault, playButtonBgPressed } = useMemo(() => {
    return getGameImages();
  }, []);

  const handlePlayFreeBet = useCallback(() => {
    setIsShowFreeBetPopup(false);
    winBarStore.setTotalWinAmount(0);
    winBarStore.updateShowAmountContainerInfo(amountContainerInfo.totalWinContainer, true);
    if (isFreeBetEnd) {
      bettingPartStore.deleteFreeBetAmountFromQuickBets(bettingPartStore.defaultBetAmount);
      showFreeBetInfo(freeBetList);
    } else {
      updateFreeBetInfo();
      bettingPartStore.addFreeBetAmountToQuickBets(freeBetList[0].amount);
      bettingPartStore.updateSelectedQuickBet(freeBetList[0].amount);
      winBarStore.setTotalWinAmount(freeBetList[0].totalWin);
      gameService.doSpin();
    }
  }, [setIsShowFreeBetPopup, isFreeBetEnd, showFreeBetInfo, freeBetList, updateFreeBetInfo]);

  return (
    <Button
      x={248}
      y={254}
      name='FreeBetFooterContainer'
      buttonText={isFreeBetEnd ? OK : PLAY}
      handleClickButton={handlePlayFreeBet}
      additionalImages={{
        buttonBgHovered: playButtonBgHovered,
        buttonBgDefault: playButtonBgDefault,
        buttonBgPressed: playButtonBgPressed,
      }}
      textStyles={{
        _fontSize: 24,
        _fontWeight: 700,
        _fill: '#16181AD9',
        _fontFamily: 'poppinsMedium',
      }}
    />
  );
});

export default FreeBetFooter;
